// extracted by mini-css-extract-plugin
module.exports = {"CarouselBorder":"styles-module--CarouselBorder--3V-6a","slide":"styles-module--slide--dkSal","carousel":"styles-module--carousel--gm2Uo"};